// extracted by mini-css-extract-plugin
module.exports = {"benefit":"BenefitsListItem_benefit__1Tkvy","icon":"BenefitsListItem_icon__31xzb","title":"BenefitsListItem_title__BhLxE"};